module.exports = __webpack_public_path__ + "img/pig1.cf8b6448.png";